import { useTranslation } from 'react-i18next';

// Values are the API's language codes; labels come from the `agents` dictionary.
export const LANGUAGE_CODES = ['en', 'es', 'fr', 'de', 'pt', 'zh', 'ja', 'ko', 'ar', 'hi'] as const;

export const useLanguageOptions = () => {
  const { t } = useTranslation('agents');

  return LANGUAGE_CODES.map((value) => ({ value, label: t(`languageOptions.${value}`) }));
};
